import { Network } from '../../../utils/network'

import urls from './urls.json'

async function testNetworkAvailable() {
  const response = await sendRequest()
  const parsedResponse = parseResponse(response)
  return parsedResponse
}

async function sendRequest() {
  const url = urls.appUpdate
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    return {
      success: true,
    }
  }
  return {
    success: false,
  }
}

export { testNetworkAvailable }
